export default __webpack_public_path__ + "static/media/wifi5.bbdd8d0e.png";